import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=59fbeb24&scoped=true&"
var script = {}
import style0 from "./Label.vue?vue&type=style&index=0&id=59fbeb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbeb24",
  null
  
)

export default component.exports